export default function WrapIf({ children, condition, wrap}) {
	return condition ? wrap(children) : children;
}
